import React from 'react';
import moment from 'moment';
import TimeIcon from '@material-ui/icons/AccessTime';

// Native OS time picker — on Android tablet opens the system clock UI (usable with touch).
// Prefer this over antd columns (no touch scroll) and dual <select> (clunky on tablet).
const inputStyle = {
  width: '100%',
  height: 44,
  fontSize: 18,
  borderRadius: 8,
  border: '1px solid #d9d9d9',
  padding: '0 12px',
  backgroundColor: 'white',
  boxSizing: 'border-box',
};

class NativeTimeInputField extends React.Component {
  emitChange(next) {
    const { input, onHandleChange } = this.props;
    const value = next.valueOf();
    // Call parent first so it can read previous form values (e.g. keep duration delta)
    if (onHandleChange) {
      onHandleChange(value);
    }
    if (input && input.onChange) {
      input.onChange(value);
    }
  }

  onChange(e) {
    const raw = e.target.value; // "HH:mm"
    if (!raw) return;
    const { input } = this.props;
    const base = input && input.value ? moment(input.value) : moment();
    const [h, m] = raw.split(':').map(Number);
    this.emitChange(base.clone().hour(h).minute(m).second(0).millisecond(0));
  }

  render() {
    const { input, containerStyle, title, mandatory, iconStyle, titleStyle } = this.props;
    const value = input && input.value ? moment(input.value) : moment();
    const hhmm = value.format('HH:mm');

    return (
      <div style={{ ...containerStyle }}>
        {title && (
          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10, alignItems: 'center' }}>
            <TimeIcon style={{ marginRight: 10, color: '#3f3f3f', ...iconStyle }} />
            <h4 style={{ margin: 0, color: '#3f3f3f', ...titleStyle }}>
              {title}{mandatory ? <span style={{ color: '#D71F4B' }}>*</span> : ''}
            </h4>
          </div>
        )}
        <input
          type="time"
          step="60"
          value={hhmm}
          onChange={e => this.onChange(e)}
          style={inputStyle}
        />
      </div>
    );
  }
}

export default NativeTimeInputField;
